// @flow
import { fetchRequest } from './index';
import type { BudgetAnalysis } from '../types';
import CommonApi from './../commonApi';
import { convertFromKopToRub } from '../helpers';

const baseUrl = 'budgetAnalysis';
const budgetAnalysis = new CommonApi<BudgetAnalysis>(baseUrl, 'Анализ затрат');

export const getExpenseDirectionInfo = async (params: any) => {
  const expenseDirectionInfo = await fetchRequest.get(
    `/${baseUrl}/getExpenseDirectionInfo`,
    params
  );
  if (expenseDirectionInfo)
    return expenseDirectionInfo.map(value => ({
      ...value,
      sum: convertFromKopToRub(value.sum)
    }));
  throw new Error('Не удалось загрузить информацию');
};

export default {
  ...budgetAnalysis,
  getExpenseDirectionInfo
};
